import { useState } from "react";
import type { BBox } from "geojson";
import { MIN_DATE, MAX_DATE } from "../settings";

function useQueryParams() {
  const [ selectedDates, setSelectedDates ] = useState<Date[]>([MIN_DATE, MAX_DATE]);
  const [ bbox, setBbox ] = useState<BBox>();

  return {
    bbox,
    setBbox,
    selectedDates,
    setSelectedDates,
  };
}

export default useQueryParams;
